import React, {FunctionComponent, createContext, useContext, useState, useEffect} from 'react';

import User from '../networking/models/User';
import AuthRepository from '../networking/repos/AuthRepository';

interface IAuthContext {
    isAuthenticated: boolean;
    isAdmin: boolean;
    logout: () => void;

    user?: User;
}

const AuthContext = createContext<IAuthContext>({} as IAuthContext);
export const useAuth = () => useContext(AuthContext);

interface Props {
    children: any;
}

const AuthContextProvider: FunctionComponent<Props> = ({ children }) => {
    const [user, setUser] = useState<User>();
    const [loaded, setLoaded] = useState<boolean>(false);

    const [authRepo] = [
        new AuthRepository()
    ];

    useEffect(() => {
        const getLoggedInUser = (): Promise<User> => {
            return authRepo.getCurrentUser();
        };

        getLoggedInUser().then((user) => {
            setUser(user);
            setLoaded(true);
        }).catch(() => {
            // TokenService.removeToken();
            setLoaded(true);
        });
    }, []);

    const logout = () => null;

    const isAuthenticated = (): boolean => user !== undefined;
    const isAdmin = (): boolean => user?.isAdmin === true;

    if(!loaded) {
        return null;
    }

    return (
        <AuthContext.Provider value={{ isAuthenticated: isAuthenticated(), isAdmin: isAdmin(), user, logout }}>
            { children }
        </AuthContext.Provider>
    );
};

export default AuthContextProvider;

